import moment from 'moment';
import React from 'react';
// Pre-Conference Webinar Announcement
const SixteenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    speaker_name,
    webinar_date_time,
    relevent_field_topic,
    conference_name,
    registration_link,
  } = values;

  return (
    <div>
      <p>
        IFERP hosting an exclusive <strong>pre-conference webinar</strong> with{' '}
        <strong>{speaker_name ? speaker_name : `[Speaker's Name]`}</strong>{' '}
        on{' '}
        <strong>
          {webinar_date_time
            ? moment(webinar_date_time).format('YYYY-MM-DD [at] HH:mm')
            : '[Date and Time Range for Registration]'}
        </strong>
        . Get early insights into{' '}
        {relevent_field_topic ? relevent_field_topic : `[Relevant Field/Topic]`}{' '}
        and join an interactive Q&A session.
      </p>

      <p>
        As a bonus, all webinar participants will receive a <strong>free certificate of
        participation</strong> and a <strong>10% discount</strong> on the conference registration fee!
      </p>
      <p>
        This is a fantastic opportunity to enhance your knowledge register now:{' '}
        {registration_link ? (
          <>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {registration_link}
            </a>
          </>
        ) : (
          `[Registration Link]`
        )}
      </p>
    </div>
  );
};

export default SixteenStepWhatsappTemplate;
